// Runtime configuration. In Kubernetes the frontend server renders /config.js from the
// aidb-config ConfigMap, so one image serves every environment. `vite dev` falls back to
// VITE_* variables.

const runtime = (typeof window !== 'undefined' && window.__AIDB_CONFIG__) || {};
const env = import.meta.env || {};

const pick = (key, viteKey, fallback) => runtime[key] ?? env[viteKey] ?? fallback;

const config = Object.freeze({
  apiBaseUrl: pick('apiBaseUrl', 'VITE_API_BASE_URL', ''),
  oidcAuthority: pick('oidcAuthority', 'VITE_OIDC_AUTHORITY', ''),
  oidcClientId: pick('oidcClientId', 'VITE_OIDC_CLIENT_ID', 'aidb-web'),
  oidcScope: pick('oidcScope', 'VITE_OIDC_SCOPE', 'openid profile email offline_access'),
  authentikEnrollUrl: pick('authentikEnrollUrl', 'VITE_AUTHENTIK_ENROLL_URL', ''),
  authentikRecoveryUrl: pick('authentikRecoveryUrl', 'VITE_AUTHENTIK_RECOVERY_URL', ''),
  authentikSettingsUrl: pick('authentikSettingsUrl', 'VITE_AUTHENTIK_SETTINGS_URL', ''),
  stripePublishableKey: pick('stripePublishableKey', 'VITE_STRIPE_PK', ''),
  // Social sign-in (provider JS SDKs, no Authentik). All public client identifiers; a provider
  // whose values are empty renders its button disabled.
  googleClientId: pick('googleClientId', 'VITE_GOOGLE_CLIENT_ID', ''),
  facebookAppId: pick('facebookAppId', 'VITE_FACEBOOK_APP_ID', ''),
  appleClientId: pick('appleClientId', 'VITE_APPLE_CLIENT_ID', ''),
  appleRedirectUri: pick('appleRedirectUri', 'VITE_APPLE_REDIRECT_URI', ''),
});

export default config;
